import { render, staticRenderFns } from "./PagoGarantizado.vue?vue&type=template&id=1ff5c38a"
import script from "./PagoGarantizado.vue?vue&type=script&lang=js"
export * from "./PagoGarantizado.vue?vue&type=script&lang=js"
import style0 from "./PagoGarantizado.vue?vue&type=style&index=0&id=1ff5c38a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports